/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type PatientAddressDtoReferenceType =
  (typeof PatientAddressDtoReferenceType)[keyof typeof PatientAddressDtoReferenceType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatientAddressDtoReferenceType = {
  NONE: 'NONE',
  PATIENT_RESIDENCE: 'PATIENT_RESIDENCE',
  PATIENT_NOTE: 'PATIENT_NOTE',
  PATIENT_HOSPITAL: 'PATIENT_HOSPITAL',
  PATIENT_ISOLATION: 'PATIENT_ISOLATION',
  PATIENT_GENERAL_DOCTOR: 'PATIENT_GENERAL_DOCTOR',
  CONTACT_PATIENT_REFERENCE_PERSON: 'CONTACT_PATIENT_REFERENCE_PERSON',
  ANAMNESIS_DOCTOR: 'ANAMNESIS_DOCTOR',
  CLINICAL_REPORT_LABORATORY: 'CLINICAL_REPORT_LABORATORY',
  CLINICAL_REPORT_DOCTOR: 'CLINICAL_REPORT_DOCTOR',
  CLINICAL_REPORT_TREATING_DOCTOR: 'CLINICAL_REPORT_TREATING_DOCTOR',
  CLINICAL_REPORT_CANTON_DOCTOR: 'CLINICAL_REPORT_CANTON_DOCTOR',
  LABORATORY_REPORT_LABORATORY: 'LABORATORY_REPORT_LABORATORY',
  TESTRESULT_FINDINGS_DOCTOR: 'TESTRESULT_FINDINGS_DOCTOR',
  TESTRESULT_XRAY: 'TESTRESULT_XRAY',
  THERAPY_DOT_APPLICANT: 'THERAPY_DOT_APPLICANT',
  THERAPY_DOT_EXECUTOR: 'THERAPY_DOT_EXECUTOR',
  THERAPY_PHASE_1: 'THERAPY_PHASE_1',
  THERAPY_PHASE_2: 'THERAPY_PHASE_2',
  THERAPY_END_REFERRAL: 'THERAPY_END_REFERRAL',
} as const;
